import { prop, propOr, compose, slice, filter, length } from 'ramda'
import { createSelector } from 'reselect'

const NUMBER_10 = 10

export const connectionSelector = createSelector(
  state => state,
  state => prop('isConnect', state)
)

export const notificationPopup = createSelector(
  state => state,
  state => compose(
    filter(item => !propOr(false, 'viewed', item)),
    propOr([], 'notificationPopup')
  )(state)
)

// выводить последние 10 непрочитанных уведомлений
export const notificationPush = createSelector(
  state => state,
  state => compose(
    slice(0, NUMBER_10),
    filter(item => !propOr(false, 'viewed', item)),
    propOr([], 'notificationPush')
  )(state)
)

// общее кол-во
export const countNotificationPush = createSelector(
  state => state,
  state => compose(
    length,
    propOr([], 'notificationPush')
  )(state)
)

// кол-во непрочитанных уведомлений
export const countNewPushSelector = createSelector(
  state => state,
  state => compose(
    length,
    filter(item => !propOr(false, 'viewed', item)),
    propOr([], 'notificationPush')
  )(state)
)
